import Marquee from "react-fast-marquee";
import { motion } from "framer-motion";

const logos = [
  { name: "NerdBug", src: "https://customer-assets.emergentagent.com/job_site-starter-kit-6/artifacts/9hxbb768_Nerdbug.png" },
  { name: "Edusko", src: "https://customer-assets.emergentagent.com/job_site-starter-kit-6/artifacts/ud6ztxex_Edusko.png" },
  { name: "Bufexx", src: "https://customer-assets.emergentagent.com/job_site-starter-kit-6/artifacts/1y00drmw_Bufesxx.png" },
  { name: "foodo", src: "https://customer-assets.emergentagent.com/job_site-starter-kit-6/artifacts/rw8cb90q_Foodo.png" },
  { name: "shecluded", src: "https://customer-assets.emergentagent.com/job_site-starter-kit-6/artifacts/nx0s1d3j_Shecluded.png" },
  { name: "Scrapays", src: "https://customer-assets.emergentagent.com/job_site-starter-kit-6/artifacts/q1zzvajm_Scrapays.png" },
  { name: "Qaya", src: "https://customer-assets.emergentagent.com/job_site-starter-kit-6/artifacts/y9z6t77z_Qaya.png" },
  { name: "Hush", src: "https://customer-assets.emergentagent.com/job_site-starter-kit-6/artifacts/2gg3vxdi_Hush.png" },
  { name: "Becuded", src: "https://customer-assets.emergentagent.com/job_site-starter-kit-6/artifacts/4ustjsjw_Becuded.png" },
  { name: "Stockhut", src: "https://customer-assets.emergentagent.com/job_site-starter-kit-6/artifacts/5vlbjbp8_Stockhut%20Icon.png" },
];

export default function BioLogos() {
  return (
    <section
      id="about"
      data-testid="bio-logos-section"
      className="relative bg-zinc-950 text-white py-24 sm:py-32 grain"
    >
      <div className="max-w-4xl mx-auto px-6 sm:px-8 text-center">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          data-testid="bio-paragraph"
          className="font-display text-2xl sm:text-3xl lg:text-4xl font-light leading-snug tracking-tight text-zinc-100"
        >
          Across my career, I&apos;ve helped startups and established businesses
          across <span className="text-white font-medium">FinTech</span>,{" "}
          <span className="text-white font-medium">EdTech</span>,{" "}
          <span className="text-white font-medium">HealthTech</span>, and{" "}
          <span className="text-white font-medium">SaaS</span> deliver products
          that people love to use and teams are proud to build.{" "}
          <span className="inline-block ml-1">🚀</span>
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="mt-8 flex items-center justify-center gap-3"
        >
          <a
            href="#contact"
            data-testid="bio-submit-brief-btn"
            className="text-xs sm:text-sm text-zinc-300 hover:text-white border border-white/15 hover:border-white/40 px-4 py-2 rounded-full transition-colors"
          >
            Submit a brief
          </a>
          <a
            href="#projects"
            data-testid="bio-view-work-btn"
            className="text-xs sm:text-sm text-zinc-300 hover:text-white border border-white/15 hover:border-white/40 px-4 py-2 rounded-full transition-colors"
          >
            View my work
          </a>
        </motion.div>
      </div>

      <div className="relative mt-16 sm:mt-20 marquee-mask-dark">
        <Marquee speed={30} gradient={false}>
          {logos.concat(logos).map((logo, i) => (
            <div
              key={i}
              data-testid={`client-logo-${i}`}
              className="mx-8 sm:mx-12 flex items-center opacity-70 hover:opacity-100 transition-opacity"
            >
              <img
                src={logo.src}
                alt={logo.name}
                loading="lazy"
                className="h-10 sm:h-12 w-auto object-contain"
              />
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
